{
  "until": "{{duration}} تا {{prayer}}",
  "begin_focus": "شروع تمرکز",
  "add_task": "افزودن وظیفه",
  "more_tasks": "+{{count}} دیگر",
  "fajr_at": "فجر ساعت {{time}}",
  "schedule_title": "امروز",
  "plan_my_day": "برنامه‌ریزی روزم",
  "planning": "در حال برنامه‌ریزی…",
  "suggested": "پیشنهادی",
  "keep_plan": "حفظ برنامه",
  "undo_plan": "واگرد",
  "plan_error": "برنامه‌ریزی ممکن نشد. دوباره تلاش کنید.",
  "plan_empty": "هنوز چیزی برای برنامه‌ریزی نیست — ابتدا وظیفه‌ای اضافه کنید.",
  "plan_settled": "همه‌چیز از قبل سر جای خود است.",
  "view_list": "فهرست",
  "view_switch_aria": "جابه‌جایی بین نمای فهرست و روز",
  "unassigned": "زمان‌بندی‌نشده",
  "assign_title": "بازه نماز",
  "no_block": "بدون بازه",
  "assign_aria": "اختصاص به یک بازه نماز",
  "open_schedule_aria": "باز کردن برنامه امروز",
  "focus_session_label": "{{block}} · تمرکز",
  "block_hero": "کار عمیق تا {{prayer}}",
  "moments_away": "لحظاتی تا {{prayer}}",
  "block_clear": "همه انجام شد — تا {{prayer}} استراحت کن",
  "alhamdulillah": "الحمدلله",
  "exit_hint": "برای خروج آرام Esc را بزنید",
  "exit_hint_touch": "برای خروج آرام ✕ را بزنید",
  "mark_done_aria": "علامت‌گذاری وظیفه به‌عنوان انجام‌شده",
  "quick_add_placeholder": "افزودن به این بازه…",
  "focus_task_aria": "تمرکز روی این وظیفه"
}
